import _ from 'lodash';
import { ROLE, THEME_VALUE } from './constants';
var filterEmpty = function (o) {
    return _.isUndefined(o) || _.isNull(o) || (_.isString(o) && _.isEmpty(o));
};
export var filterEmptyParams = function (obj) {
    var result = _.omitBy(obj, function (v) { return filterEmpty(v); });
    return result;
};
export var findCurrentMenu = function (menus, index, crumb) {
    var _a;
    var _me = menus[index];
    if (!_me) {
        return undefined;
    }
    if (_me === null || _me === void 0 ? void 0 : _me.children) {
        return findCurrentMenu(_me.children, 0, crumb);
    }
    else {
        var _menu = (_a = _me === null || _me === void 0 ? void 0 : _me.path) === null || _a === void 0 ? void 0 : _a.includes(crumb);
        if (!_menu) {
            return findCurrentMenu(menus, index + 1, crumb);
        }
        return menus[index];
    }
};
export var filesToBase64 = function (fileArray) {
    var promises = fileArray.map(function (file) {
        return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onload = function (event) {
                resolve(event.target.result); // Extract base64 data
            };
            reader.onerror = function (error) {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    });
    return Promise.all(promises);
};
export var getDefaultTheme = function () {
    var isDark = window.matchMedia('(prefers-color-scheme:dark)').matches;
    return isDark ? THEME_VALUE.DARK : THEME_VALUE.LIGHT;
};
export var DEFAULT_LANGUAGE = 'enUK';
export var DEFAULT_FONT_FAMILY = 'Lato';
export var convertURLObject = function (url) {
    var tempValue = JSON.stringify(url);
    var queryParams = encodeURIComponent(tempValue);
    return queryParams;
};
export var isAllowPermission = function (role, functions, functionNames) {
    if (role === void 0) { role = ''; }
    if (functions === void 0) { functions = []; }
    if (functionNames === void 0) { functionNames = []; }
    if (role === ROLE.SUPER_ADMIN)
        return true;
    return _.every(functionNames, function (func) { return functions.includes(func); });
};
